module.exports = __webpack_public_path__ + "static/media/conditions_site_20201020.321e3cc3.pdf";